<script setup lang="ts">

import {ref, watch} from "vue";

const adjust = ref<Boolean>(false);
const adjustIndex = ref<Number>(1);

const markAll = ref<Boolean>(true);
const markMarketing = ref<Boolean>(true);
const markAnalytics = ref<Boolean>(true);
const cookiesAccepted = ref<boolean>(checkInitialCookieAccepted());

watch(markAll, (newValue) => {
    markMarketing.value = newValue;
    markAnalytics.value = newValue;
});

function save(all: Boolean = false) {
    const maxAge = 60 * 60 * 24 * 30;

    if (all) {
        markMarketing.value = true;
        markAnalytics.value = true;
    }

    document.cookie = `cookies_accepted=true; path=/; max-age=${maxAge}`;
    document.cookie = `markMarketing=${markMarketing.value}; path=/; max-age=${maxAge}`;
    document.cookie = `markAnalytics=${markAnalytics.value}; path=/; max-age=${maxAge}`;

    cookiesAccepted.value = true;

}

function getCookie(name: string) {
    const value = document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='));
    return value ? value.split('=')[1] : null;
}

function checkInitialCookieAccepted(): boolean {
    return getCookie('cookies_accepted') === 'true';
}
</script>

<template>
    <div class="fixed w-full h-full flex justify-center items-center z-9999 p-4 bg-dark-blue/60"
         v-if="!cookiesAccepted"
    >

        <div class="bg-white text-dark-blue p-4 md:p-6 max-h-full overflow-auto max-w-4xl">
            <div :class="{'hidden': adjust}">
                <h1 class="text-2xl md:text-3xl text-center">Dbamy o prywatność<br> i bezpieczeństwo danych</h1>

                <p class="mt-6 text-base md:text-lg">Stosujemy pliki cookies, aby nasze strona pozostała niezawodna i bezpieczna, a
                    także
                    w celu
                    personalizacji treści i reklam, zapewnienia funkcji mediów społecznościowych oraz do analizy
                    odwiedzin strony. W tych celach zbieramy dane o użytkownikach, ich zachowaniach oraz
                    urządzeniach. Informacje o tym, jak korzystasz z naszej witryny możemy udostępnić naszym
                    partnerom wspierającym nas w mediach społecznościowych, reklamie i analizie, którzy mogą
                    łączyć je z innymi informacjami, które im dostarczyłeś lub które zgromadzili podczas
                    korzystania z ich usług.
                </p>

                <p class="text-gray-400 text-xs mt-4">
                    Poprzez kliknięcie „Akceptuj wszystko” zgadzasz się na używanie przez nas wszystkich plików
                    cookies wskazanych w Polityce Prywatności. Wybierz “Dostosuj” aby zapoznać się ze
                    szczegółami i zarządzać opcjami. Możesz dostosować swoje preferencje w każdym momencie. Aby
                    uzyskać więcej informacji, zapoznaj się z naszą Polityką Prywatności.
                </p>

                <div class="flex justify-between w-full mt-5 gap-4 md:gap-10 flex-wrap md:flex-nowrap">

                    <button
                        class="!px-5 !py-3 w-full !bg-white border  border-dark-blue !text-dark-blue cursor-pointer"
                        @click="adjust = true">
                        Dostosuj
                    </button>
                    <button class="!px-5 !py-3 w-full cursor-pointer" @click="save(true)">
                        Akceptuj
                    </button>
                </div>
            </div>

            <div
                class="w-full md:w-auto  relative flex flex-col justify-center items-center bg-white p-4"
                :class="{'hidden': !adjust}">

                <div class="flex flex-wrap sm:flex-nowrap justify-between gap-5 w-full mb-10">
                    <h2 class="text-xl md:text-2xl">USTAWIENIA PREFERENCJI</h2>

                    <label class="ml-auto sm:ml-0 inline-flex items-center cursor-pointer">
                        <input type="checkbox" value="" class="sr-only peer" v-model="markAll">
                        <div
                            class="shrink-0 relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-light-blue dark:peer-focus:ring-light-blue rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-dark-blue"></div>
                        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Zaznacz wszystkie</span>
                    </label>
                </div>

                <hr>
                <div class="flex">
                    <div class="w-1/3 mr-1 sm:mr-6">
                        <div class="text-white p-2 md:p-4 text-sm md:text-base uppercase" :class="adjustIndex == 1 ? 'bg-dark-blue' : 'bg-gray-400'"
                             @click="adjustIndex = 1">
                            Niezbędne Polityki cookie
                        </div>
                        <div class="text-white p-2 md:p-4 text-sm md:text-base uppercase" :class="adjustIndex == 2 ? 'bg-dark-blue' : 'bg-gray-400'"
                             @click="adjustIndex = 2">
                            Wydajność sieci i analityka
                        </div>
                        <div class="text-white p-2 md:p-4 text-sm md:text-base uppercase" :class="adjustIndex == 3 ? 'bg-dark-blue' : 'bg-gray-400'"
                             @click="adjustIndex = 3">
                            Pliki cookie dla celów marketingowych
                        </div>
                    </div>

                    <div class="w-2/3" :class="{'hidden': adjustIndex !== 1}">
                        <p>Dane gromadzone przez te pliki są niezbędne w celu zagwarantowania działania witryny od
                            strony technicznej, w celu zapewnienia podstawowych funkcji związanych z zakupami, jak
                            również w celu zapewnienia bezpieczeństwa oraz zapobiegania oszustwom. Zawsze
                            włączone.
                        </p>
                    </div>

                    <div class="w-2/3" :class="{'hidden': adjustIndex !== 2}">
                        <p>
                            Używamy tych danych do poprawy działania naszych witryn i usług, a także do przeprowadzania
                            doświadczeń użytkowników i analiz biznesowych naszych sklepów i aplikacji.
                        </p>
                        <label class="inline-flex items-center cursor-pointer mt-2">
                            <input type="checkbox" value="" class="sr-only peer" v-model="markAnalytics">
                            <div
                                class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-light-blue dark:peer-focus:ring-light-blue rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-dark-blue"></div>
                            <span class="ms-3 text-sm font-medium text-gray-900 ">Włączone</span>
                        </label>
                    </div>

                    <div class="w-2/3" :class="{'hidden': adjustIndex !== 3}">
                        <p>
                            Gromadzą informacje o historii użytkownika, aby zapewnić właściwe treści sponsorowane
                            dotyczące naszych produktów. Możemy udostępniać te informacje, takie jak zaszyfrowany adres
                            e-mail lub szczegóły urządzenia oraz identyfikator klienta stronom trzecim, np. serwisom
                            Facebook lub Google. Celem jest prezentowanie właściwych reklam na stronach i w aplikacjach
                            stron trzecich. Możemy także łączyć te dane między różnymi urządzeniami, z których
                            korzystasz, jak również przetwarzać dane dotyczące reklam (przykładowo, czy kliknięcie
                            reklamy doprowadziło do zakupu). Służy to ocenie skuteczności reklamy oraz umożliwia jej
                            fakturowanie. Możesz włączyć lub wyłączyć ich użycie według własnego uznania..
                        </p>
                        <label class="inline-flex items-center cursor-pointer mt-2">
                            <input type="checkbox" value="" class="sr-only peer" v-model="markMarketing">
                            <div
                                class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-light-blue dark:peer-focus:ring-light-blue rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-dark-blue"></div>
                            <span class="ms-3 text-sm font-medium text-gray-900">Włączone</span>
                        </label>
                    </div>
                </div>

                <div class="w-full text-right cursor-pointer mt-5">
                    <button class="w-full md:w-auto" @click="save(false)">Zapisz ustawienia</button>
                </div>
            </div>


        </div>
    </div>

</template>

<style scoped>

</style>
